import Template, { templateLanguages } from "../app/models/Template";
import Language, {
  templateStatus,
  button as templateButton,
  templateButtonType,
  accountData,
  accountType,
} from "../app/models/Language";
import * as server from "../api/server/templateMessage";
import * as servTemplate from "../db/serviceTemplate";
import { format } from "date-fns";
import { Timestamp, createRef } from "../db";
import db from "../db";
import * as Log from "../util/SDayslogger";
import { getAccountByID } from "../db/serviceAccount";

// Status mapping function to ensure Meta API status values are properly handled
const mapMetaAPIStatusToInternal = (metaStatus: string): string => {
  console.log(`[Status Mapping] Input Meta API status: "${metaStatus}"`);
  
  // Meta API returns uppercase status values, but our internal enum already matches these
  const statusMap: { [key: string]: string } = {
    'APPROVED': templateStatus.approved,     // "APPROVED"
    'PENDING': templateStatus.pending,       // "PENDING" 
    'REJECTED': templateStatus.rejected,     // "REJECTED"
    'IN_APPEAL': templateStatus.in_appeal,   // "IN_APPEAL"
    'DISABLED': templateStatus.disable_update, // "DISABLED"
    'PAUSED': templateStatus.paused,         // "PAUSED"
    'FLAGGED': templateStatus.flagged,       // "FLAGGED"
    'REINSTATED': templateStatus.reinstated  // "REINSTATED"
  };
  
  const mappedStatus = statusMap[metaStatus?.toUpperCase()] || templateStatus.pending;
  console.log(`[Status Mapping] Mapped "${metaStatus}" -> "${mappedStatus}"`);
  
  return mappedStatus;
};

export const updateOrCreateWhatsappTemplate = async (
  newTemplate: any,
  newLanguage: any,
  whatsappBusinessID: string,
  whatsappAccessToken: string,
  isUpdateStage: boolean,
  templateID: string,
  accountID: string,
  templateAccounts: any | undefined,
  callback: any
) => {
  console.log(newLanguage, "_newlanguage");
  console.log("MASUK updateOrCreateWhatsappTemplate komen");

  let template: any;
  if (newTemplate) {
    /***
     * Convert Object To Updatable
     */
    template = JSON.parse(JSON.stringify(newTemplate));
    // template.account = newTemplate.account; //temporary
    // template.company = newTemplate.company; //temporary
    template.client = newTemplate.client;
    template.accounts = newTemplate.accounts;
    template.companies = newTemplate.companies;
    template.languages = newTemplate.languages;
    template.createdAt = newTemplate.createdAt;
    template.updatedAt = newTemplate.updatedAt;
    template.isActive = true;
    /***
     * End Convert Object To Updatable
     */

    let mediaType = "";
    if (newLanguage && newLanguage.header && newLanguage.header.type) {
      if (newLanguage.header.type === "media") {
        mediaType = newLanguage.header.mediaType;
      } else {
        mediaType = newLanguage.header.type;
      }
    }
    console.log("komen Check Stage : " + isUpdateStage);
    const accountRef = createRef("account", accountID);
    let responseTemplateID: string = "";
    if (templateAccounts && templateAccounts.length > 0) {
      const findTemplateAccount = templateAccounts.find(
        (acc: any) =>
          acc.account.id === accountID && acc.type === accountType.whatsapp
      );
      console.log(`findTemplateAccount `, findTemplateAccount);
      if (
        findTemplateAccount &&
        findTemplateAccount.responseTemplateID !== ""
      ) {
        responseTemplateID = findTemplateAccount.responseTemplateID
          ? findTemplateAccount.responseTemplateID
          : "";
      }
    }
    /***
     * Process For Update Template
     */
    if (isUpdateStage) {
      console.log("MASUK IF UPDATE TEMPLATE komen");

      await server
        .sendRequestCreateTemplate(
          mediaType,
          newLanguage,
          newTemplate,
          whatsappBusinessID,
          whatsappAccessToken,
          isUpdateStage,
          newLanguage.responseTemplateID,
          async (
            updateStatus: boolean,
            responseJson: string,
            errorMessage: string,
            errorResponse: string
          ) => {
            console.log(
              "komen Hasil Request Update Template - Response Request : \n updateStatus : " +
                updateStatus +
                " \n reponseJSOn : " +
                JSON.stringify(responseJson) +
                " \n errorMessage : " +
                errorMessage +
                " \n errorResponse : " +
                JSON.stringify(errorResponse)
            );

            let resultLanguage = { ...newLanguage };
            const jsonResp: any = JSON.stringify(responseJson) || "";
            console.log(jsonResp, "json_Res");
            if (resultLanguage && !resultLanguage.createdAt) {
              resultLanguage.createdAt = template.createdAt;
            }
            if (updateStatus) {
              const newAccountsData = templateAccounts?.map(
                (accountData: any) => {
                  if (accountData.account.id === accountID) {
                    return {
                      ...accountData,
                      updatedAt: Timestamp.now(),
                      responseJSON: jsonResp
                        ? jsonResp
                        : accountData.responseJSON,
                    };
                  } else {
                    return accountData;
                  }
                }
              );
              console.log(`newAccountsData `, newAccountsData);
              //Update Template Success
              if (responseJson) {
                resultLanguage.responseJSON = JSON.stringify(responseJson);
                
                // Extract and map status from Meta API response
                const metaAPIStatus = (responseJson as any)?.status;
                if (metaAPIStatus) {
                  const mappedStatus = mapMetaAPIStatusToInternal(metaAPIStatus);
                  console.log(`[Template Update] Meta API returned status: "${metaAPIStatus}", mapped to: "${mappedStatus}"`);
                  resultLanguage.status = mappedStatus;
                } else {
                  console.log(`[Template Update] No status in response, using default: ${templateStatus.pending}`);
                  resultLanguage.status = updateStatus ? templateStatus.pending : templateStatus.rejected;
                }
              } else {
                // Fallback for when no response JSON
                resultLanguage.status = updateStatus ? templateStatus.pending : templateStatus.rejected;
              }
              
              const newTemplateLanguages: templateLanguages[] =
                template.languages?.map((acc: any) => {
                  if (
                    acc.templateLanguage === resultLanguage.language!
                    // &&
                    // acc.account?.id === accountID
                  ) {
                    return {
                      ...acc,
                      account: accountRef,
                      templateStatus: resultLanguage.status,
                      // templateStatus.rejected,
                    };
                  } else {
                    return acc;
                  }
                });
              template.languages = newTemplateLanguages;
              resultLanguage.updatedAt = Timestamp.now();
              const now = new Date();
              template.updatedAt = Timestamp.now();
              await servTemplate.updateTemplate(template, templateID);
              
              // Verify language document exists before updating (UPDATE flow)
              const updateLanguageId = `${newLanguage.language}_${whatsappBusinessID}`;
              console.log(`[Template Update] Verifying language document: ${updateLanguageId}`);
              
              try {
                const languageDoc = await db
                  .collection("templates")
                  .doc(templateID)
                  .collection("languages")
                  .doc(updateLanguageId)
                  .get();
                  
                if (languageDoc.exists) {
                  console.log(`[Template Update] ✅ Language document exists, updating with status: ${resultLanguage.status}`);
                  await servTemplate.updateLanguage(
                    templateID,
                    updateLanguageId,
                    resultLanguage
                  );
                  console.log(`[Template Update] ✅ Successfully updated language status to: ${resultLanguage.status}`);
                } else {
                  console.error(`[Template Update] ❌ Language document does not exist: ${updateLanguageId}`);
                }
              } catch (error) {
                console.error(`[Template Update] Error checking/updating language document:`, error);
              }
              //updated templateAccounts
              if (newAccountsData && newAccountsData.length > 0) {
                newAccountsData.forEach(async (templateAcc: any) => {
                  if (
                    !templateAcc.id &&
                    templateAcc.account &&
                    templateAcc.account.id === accountID
                  ) {
                    console.log(templateID, "templateID 201 tempacc");
                    console.log(
                      resultLanguage.language,
                      "resultLanguage.language 201 tempacc"
                    );
                    console.log(templateAcc, "templateAcc 201 tempacc");

                    await servTemplate.createTemplateAccounts(
                      templateID,
                      resultLanguage.language!,
                      templateAcc
                    );
                  }
                  if (
                    templateAcc.id &&
                    templateAcc.account &&
                    templateAcc.account.id === accountID
                  ) {
                    await servTemplate.updateTemplateAccounts(
                      templateID,
                      resultLanguage.language!,
                      templateAcc
                    );
                  }
                });
              }
              console.log("before if updatedAt:");
              callback(template);
            } else if (
              !updateStatus &&
              (!errorMessage || errorMessage === "")
            ) {
              //Update Template Failed
              const newAccountsData = templateAccounts?.map(
                (accountData: any) => {
                  if (accountData.account.id === accountID) {
                    return {
                      ...accountData,
                      errorMessage: errorMessage ? errorMessage : "",
                      errorResponse: errorResponse
                        ? JSON.stringify(errorResponse)
                        : "",
                      responseJSON: jsonResp
                        ? jsonResp
                        : accountData.responseJSON,
                      updatedAt: Timestamp.now(),
                    };
                  } else {
                    return accountData;
                  }
                }
              );
              console.log(`newAccountsData `, newAccountsData);
              if (errorMessage) {
                resultLanguage.errorMessage = errorMessage;
              }
              if (errorResponse) {
                resultLanguage.responseJSON = JSON.stringify(errorResponse);
              }
              const newTemplateLanguages: templateLanguages[] =
                template.languages?.map((acc: any) => {
                  if (
                    acc.templateLanguage === resultLanguage.language!
                    // &&
                    // acc.account?.id === accountID
                  ) {
                    return {
                      ...acc,
                      account: accountRef,
                      templateStatus: resultLanguage.status,
                      // templateStatus.rejected,
                    };
                  } else {
                    return acc;
                  }
                });
              template.languages = newTemplateLanguages;
              // Keep status as rejected for error case
              resultLanguage.status = templateStatus.rejected;
              resultLanguage.updatedAt = Timestamp.now();
              const now = new Date();
              template.updatedAt = Timestamp.now();
              await servTemplate.updateTemplate(template, templateID);
              await servTemplate.updateLanguage(
                templateID,
                `${newLanguage.language}_${whatsappBusinessID}`,
                resultLanguage
              );
              //updated templateAccounts
              if (newAccountsData && newAccountsData.length > 0) {
                newAccountsData.forEach(async (templateAcc: any) => {
                  if (
                    !templateAcc.id &&
                    templateAcc.account &&
                    templateAcc.account.id === accountID
                  ) {
                    console.log(templateID, "templateID 318 tempacc");
                    console.log(
                      resultLanguage.language,
                      "resultLanguage.language 318 tempacc"
                    );
                    console.log(templateAcc, "templateAcc 318 tempacc");
                    await servTemplate.createTemplateAccounts(
                      templateID,
                      resultLanguage.language!,
                      templateAcc
                    );
                  }
                  if (
                    templateAcc.id &&
                    templateAcc.account &&
                    templateAcc.account.id === accountID
                  ) {
                    await servTemplate.updateTemplateAccounts(
                      templateID,
                      resultLanguage.language!,
                      templateAcc
                    );
                  }
                });
              }

              callback(template);
            } else {
              callback(undefined);
            }
          }
        )
        .then(async (response) => {
          //After Request New Template
        })
        .catch(function (error) {
          //Error Response
          Log.error("Edit Template : sendRequestCreateTemplate " + error)

        });

      /***
       * Process For Create Template
       */
    } else {
      Log.debug(`Create Template for wabaId ${whatsappBusinessID}`);

      await server
        .sendRequestCreateTemplate(
          mediaType,
          newLanguage,
          newTemplate,
          whatsappBusinessID,
          whatsappAccessToken,
          isUpdateStage,
          "",
          async (
            respTemplateID: string,
            responseJson: string,
            errorMessage: string,
            errorResponse: string,
            accountData: any
          ) => {
            try {
              console.log("MASUK sendRequestCreateTemplate komen");
              console.log(respTemplateID, "respTemplateID komen");
              console.log(responseJson, "responseJson komen");
              console.log(errorResponse, "errorResponse komen");
              console.log(accountData, "accountData from server komen");

              console.log(
                "Hasil Request Create Template - Response Request : \n responsetemplateID : " +
                  respTemplateID +
                  " \n reponseJSOn : " +
                  JSON.stringify(responseJson) +
                  " \n errorMessage : " +
                  errorMessage +
                  " \n errorResponse : " +
                  JSON.stringify(errorResponse)
              );
              let resultLanguage = { ...newLanguage };
              console.log(resultLanguage, "resultLanguage komen");
              let newAccountsData: accountData[] =
                templateAccounts && templateAccounts !== undefined
                  ? templateAccounts
                  : [];
              console.log(newAccountsData, "newAccountsData komen");
              let newTemplateLanguage: any[] = template.languages
                ? template.languages
                : [];
              if (resultLanguage && !resultLanguage.createdAt) {
                resultLanguage.createdAt = template.createdAt;
              }
              if (respTemplateID && respTemplateID !== "") {
                console.log("MASUK IF UPDATE TEMPLATE SUCCESS komen");

                //Update Template Success
                resultLanguage.responseTemplateID = respTemplateID;
                resultLanguage.responseJSON = JSON.stringify(responseJson);
                resultLanguage.updatedAt = Timestamp.now();
                const now = new Date();
                const findTemplateAccount = newAccountsData.find(
                  (templateAccount) =>
                    templateAccount.account &&
                    templateAccount.account.id === accountID
                );
                const jsonResp = resultLanguage.responseJSON;
                let rawMetaStatus;
                let jsonTemplateStatus;
                
                try {
                  const parsedResp = JSON.parse(jsonResp);
                  rawMetaStatus = parsedResp.status;
                  console.log(`[Template Create] Raw Meta API status from response: "${rawMetaStatus}"`);
                  
                  if (rawMetaStatus !== undefined) {
                    jsonTemplateStatus = mapMetaAPIStatusToInternal(rawMetaStatus);
                    console.log(`[Template Create] Mapped status: "${rawMetaStatus}" -> "${jsonTemplateStatus}"`);
                  } else {
                    jsonTemplateStatus = templateStatus.pending;
                    console.log(`[Template Create] No status in response, using default: "${jsonTemplateStatus}"`);
                  }
                } catch (error) {
                  console.error(`[Template Create] Error parsing response JSON:`, error);
                  jsonTemplateStatus = templateStatus.pending;
                }

                console.log(`[Template Create] Final status values:`);
                console.log(`- Raw Meta API status: "${rawMetaStatus}"`);
                console.log(`- Mapped internal status: "${jsonTemplateStatus}"`);
                console.log(`- Response JSON:`, jsonResp);
                if (!findTemplateAccount) {
                  console.log("MASUK IF !findTemplateAccount");
                  
                  // 🔧 FIX: Use server's accountId to create proper DocumentReference
                  const finalAccountRef = (accountData && accountData.accountId) ? 
                    createRef("account", accountData.accountId) : accountRef;
                  console.log(`[Template Create] Using account ref:`, finalAccountRef);
                  console.log(`[Template Create] Account ref type:`, typeof finalAccountRef);
                  console.log(`[Template Create] Server provided accountData:`, accountData);
                  
                  const newAccountData: accountData = {
                    account: finalAccountRef,
                    type: accountType.whatsapp,
                    responseJSON: jsonResp,
                    responseTemplateID: respTemplateID,
                    status: jsonTemplateStatus,
                    createdAt: Timestamp.now(),
                    updatedAt: Timestamp.now(),
                  };
                  console.log(`komen newAccountData if : `, newAccountData);
                  newAccountsData.push(newAccountData);
                } else {
                  console.log("MASUK ELSE !findTemplateAccount");
                  newAccountsData = newAccountsData.map((templateAccount) => {
                    if (
                      templateAccount.account &&
                      templateAccount.account.id! === accountID
                    ) {
                      return {
                        ...templateAccount,
                        updatedAt: Timestamp.now(),
                        responseJSON: jsonResp,
                        responseTemplateID: respTemplateID,
                        status: jsonTemplateStatus,
                      };
                    } else return templateAccount;
                  });
                }
                // Use the properly mapped status from Meta API response
                console.log(`[Template Create] Setting resultLanguage.status to: "${jsonTemplateStatus}"`);
                resultLanguage.status = jsonTemplateStatus;
                console.log(`komen newAccountsData else : `, newAccountsData);
                
                console.log(`[Template Create] Status consistency check:`);
                console.log(`- jsonTemplateStatus: "${jsonTemplateStatus}"`);
                console.log(`- resultLanguage.status: "${resultLanguage.status}"`);
                
                const newTemplateLanguages: templateLanguages[] =
                  template.languages?.map((acc: templateLanguages) => {
                    if (
                      acc.templateLanguage === resultLanguage.language! &&
                      acc.account?.id === accountID
                      // `${acc.templateLanguage}_${whatsappBusinessID}` ===
                      // `${resultLanguage.language!}_${whatsappBusinessID}`
                    ) {
                      // 🔧 FIX: Use server's accountId to create proper DocumentReference
                      const finalAccountRef = (accountData && accountData.accountId) ? 
                        createRef("account", accountData.accountId) : accountRef;
                      
                      const newDataLanguage: templateLanguages = {
                        templateLanguage: acc.templateLanguage,
                        account: finalAccountRef,
                        templateStatus: resultLanguage.status, // ✅ Use resultLanguage.status instead of jsonTemplateStatus
                      };
                      console.log(`[Template Create] ✅ Setting template languages array status to: "${resultLanguage.status}"`);
                      return newDataLanguage;
                    } else {
                      return acc;
                    }
                  });
                console.log(
                  `komen [template.client] newTemplateLanguages : `,
                  newTemplateLanguages
                );
                
                // 🔧 VALIDATION: Ensure all language entries have account fields
                const languagesWithoutAccount = newTemplateLanguages.filter(lang => !lang.account);
                if (languagesWithoutAccount.length > 0) {
                  console.error(`[Template Create] ❌ Found ${languagesWithoutAccount.length} language entries without valid account field:`, languagesWithoutAccount);
                  
                  // Try to fix missing account fields
                  const finalAccountRef = (accountData && accountData.accountId) ? 
                    createRef("account", accountData.accountId) : accountRef;
                  languagesWithoutAccount.forEach((lang, index) => {
                    console.log(`[Template Create] 🔧 Fixing missing account field for language: ${lang.templateLanguage}`);
                    newTemplateLanguages[newTemplateLanguages.indexOf(lang)].account = finalAccountRef;
                  });
                } else {
                  console.log(`[Template Create] ✅ All ${newTemplateLanguages.length} language entries have valid account fields`);
                }
                
                // 🔧 FIX: Ensure current language exists in array
                let currentLanguageInArray = newTemplateLanguages.find(
                  lang => lang.templateLanguage === resultLanguage.language
                );
                
                if (!currentLanguageInArray) {
                  console.log(`[Template Create] 🔧 Language ${resultLanguage.language} not found in array, adding it`);
                  const finalAccountRef = (accountData && accountData.accountId) ? 
                    createRef("account", accountData.accountId) : accountRef;
                  const newLanguageEntry: templateLanguages = {
                    templateLanguage: resultLanguage.language!,
                    account: finalAccountRef,
                    templateStatus: resultLanguage.status
                  };
                  newTemplateLanguages.push(newLanguageEntry);
                  currentLanguageInArray = newLanguageEntry;
                }
                
                // Validate status consistency
                console.log(`[Template Create] Status consistency validation:`);
                console.log(`- Template languages array status: "${currentLanguageInArray?.templateStatus}"`);
                console.log(`- Individual language document status: "${resultLanguage.status}"`);
                
                if (currentLanguageInArray?.templateStatus !== resultLanguage.status) {
                  console.error(`[Template Create] ❌ STATUS MISMATCH DETECTED!`);
                  console.error(`Array: "${currentLanguageInArray?.templateStatus}" vs Document: "${resultLanguage.status}"`);
                } else {
                  console.log(`[Template Create] ✅ Status consistency verified: "${resultLanguage.status}"`);
                }
                
                template.languages = newTemplateLanguages;
                template.updatedAt = Timestamp.now(); //{seconds : Timestamp.now().seconds, nanoseconds: Timestamp.now().nanoseconds};
                
                const firestoreLanguageId = `${newLanguage.language}_${whatsappBusinessID}`;
                console.log(`[Template Create] About to save to Firestore:`);
                console.log(`- Template ID: ${templateID}`);
                console.log(`- Language ID: ${firestoreLanguageId}`);
                console.log(`- Status to save: ${resultLanguage.status}`);
                console.log(`- Response Template ID: ${resultLanguage.responseTemplateID}`);
                console.log(`- WABA ID: ${whatsappBusinessID}`);
                console.log(template, "template komen");
                console.log(newLanguage.language, "newLanguage.language komen");
                console.log(resultLanguage, "resultLanguage komen");
                
                await servTemplate.updateTemplate(template, templateID);
                
                // Verify language document exists before updating
                try {
                  const languageDoc = await db
                    .collection("templates")
                    .doc(templateID)
                    .collection("languages")
                    .doc(firestoreLanguageId)
                    .get();
                    
                  if (languageDoc.exists) {
                    console.log(`[Template Create] ✅ Language document exists, updating with status: ${resultLanguage.status}`);
                    await servTemplate.updateLanguage(
                      templateID,
                      firestoreLanguageId,
                      resultLanguage
                    );
                    console.log(`[Template Create] ✅ Successfully updated language status to: ${resultLanguage.status}`);
                  } else {
                    console.error(`[Template Create] ❌ Language document does not exist: ${firestoreLanguageId}`);
                    console.log(`[Template Create] Creating new language document with status: ${resultLanguage.status}`);
                    await servTemplate.addCampaignLanguage(templateID, firestoreLanguageId, resultLanguage);
                  }
                } catch (error) {
                  console.error(`[Template Create] Error checking/updating language document:`, error);
                }
                
                console.log(`[Template Create] ✅ Successfully saved template and language to Firestore`);
                //updated templateAccounts
                if (newAccountsData && newAccountsData.length > 0) {
                  newAccountsData.forEach(async (templateAcc) => {
                    if (
                      !templateAcc.id &&
                      templateAcc.account &&
                      templateAcc.account.id === accountID
                    ) {
                      console.log(templateID, "templateID 537 tempacc");
                      console.log(
                        resultLanguage.language,
                        "resultLanguage.language 537 tempacc"
                      );
                      console.log(templateAcc, "templateAcc 537 tempacc");
                      await servTemplate.createTemplateAccounts(
                        templateID,
                        `${resultLanguage.language!}_${whatsappBusinessID}`,
                        templateAcc
                      );
                    }
                    if (
                      templateAcc.id &&
                      templateAcc.account &&
                      templateAcc.account.id === accountID
                    ) {
                      await servTemplate.updateTemplateAccounts(
                        templateID,
                        `${resultLanguage.language!}_${whatsappBusinessID}`,
                        templateAcc
                      );
                    }
                  });
                }

                callback(template);
              } else {
                //if((!respTemplateID ||  respTemplateID === "") && (!errorMessage || errorMessage === "")){
                //Update Template Failed
                resultLanguage.errorMessage = errorMessage;
                resultLanguage.responseJSON = JSON.stringify(errorResponse);
                resultLanguage.status = templateStatus.rejected;
                resultLanguage.updatedAt = Timestamp.now();
                let newAccountsData: accountData[] = templateAccounts
                  ? templateAccounts
                  : [];
                let newTemplateLanguage: any[] = template.languages
                  ? template.languages
                  : [];
                const jsonResp: any = resultLanguage.responseJSON;

                console.log(resultLanguage, "resultLanguage ikome");
                // console.log(jsonResp, "jsonResp ikome");
                console.log(JSON.parse(jsonResp).status, "status json ikome");
                //find if not found newAccountsData
                const findTemplateAccount = newAccountsData.find(
                  (templateAccount) =>
                    templateAccount.account &&
                    templateAccount.account.id === accountID
                );
                if (!findTemplateAccount) {
                  const newAccountData: accountData = {
                    account: accountRef,
                    type: accountType.whatsapp,
                    errorMessage: errorMessage ? errorMessage : "",
                    responseJSON: jsonResp,
                    responseTemplateID: respTemplateID,
                    status: templateStatus.rejected,
                    createdAt: Timestamp.now(),
                    updatedAt: Timestamp.now(),
                  };
                  console.log(`newAccountData : `, newAccountData);
                  newAccountsData.push(newAccountData);
                } else {
                  newAccountsData = newAccountsData.map((templateAccount) => {
                    if (
                      templateAccount.account &&
                      templateAccount.account.id! === accountID
                    ) {
                      return {
                        ...templateAccount,
                        updatedAt: Timestamp.now(),
                        errorMessage: errorMessage ? errorMessage : "",
                        responseJSON: jsonResp,
                        responseTemplateID: respTemplateID,
                        status: templateStatus.rejected,
                      };
                    } else return templateAccount;
                  });
                }
                console.log(`newAccountsData `, newAccountsData);
                console.log(template, "ini adaalah template orx");
                const newTemplateLanguages: templateLanguages[] =
                  template.languages?.map((acc: any) => {
                    console.log(acc, "ini acc orx");
                    if (
                      acc.templateLanguage === resultLanguage.language!
                      // &&
                      // acc.account?.id === accountID
                    ) {
                      return {
                        ...acc,
                        account: accountRef,
                        templateStatus: resultLanguage.status,
                        // templateStatus.rejected,
                      };
                    } else {
                      return acc;
                    }
                  });
                console.log(
                  `[template.client] newTemplateLanguages : `,
                  newTemplateLanguages
                );
                template.languages = newTemplateLanguages;
                const now = new Date();
                template.updatedAt = Timestamp.now();
                console.log(resultLanguage, "resultlang orx");
                console.log(template, "template orx komen");
                console.log(newTemplateLanguages, "newtemplang orx komen");
                console.log(templateID, "templateID orx");
                console.log(`${newLanguage.language}_${whatsappBusinessID}  orx`);
                await servTemplate.updateTemplate(template, templateID);
                await servTemplate.updateLanguage(
                  templateID,
                  `${newLanguage.language}_${whatsappBusinessID}`,
                  resultLanguage
                );
                
                //updated templateAccounts
                if (newAccountsData && newAccountsData.length > 0) {
                  newAccountsData.forEach(async (templateAcc) => {
                    if (
                      !templateAcc.id &&
                      templateAcc.account &&
                      templateAcc.account.id === accountID
                    ) {
                      console.log(templateID, "templateID 685 tempacc");
                      console.log(
                        resultLanguage.language,
                        "resultLanguage.language 685 tempacc"
                      );
                      console.log(templateAcc, "templateAcc 685 tempacc");
                      await servTemplate.createTemplateAccounts(
                        templateID,
                        `${resultLanguage.language!}_${whatsappBusinessID}`,
                        templateAcc
                      );
                    }
                    if (
                      templateAcc.id &&
                      templateAcc.account &&
                      templateAcc.account.id === accountID
                    ) {
                      await servTemplate.updateTemplateAccounts(
                        templateID,
                        `${resultLanguage.language!}_${whatsappBusinessID}`,
                        templateAcc
                      );
                    }
                  });
                }

                callback(template);
              }
              // else{
              //   callback(undefined);
              // }
            } catch (error) {
              Log.error("Process Template Update : sendRequestCreateTemplate " + error)              
            }
          }
        )
        .then(async (response) => {
          //After Request New Template
        })
        .catch(function (error) {
          //Error Response
          callback(undefined);
          Log.error("Create Template : sendRequestCreateTemplate " + error)
          
        });
    }
  }
};
